document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-conversion-tools]').forEach(function (section) {
    var postcodeForm = section.querySelector('[data-postcode-form]');
    var prefixes = (section.dataset.corePostcodes || '').split(',').map(function (value) { return value.trim().toUpperCase(); }).filter(Boolean);
    if (postcodeForm) {
      postcodeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = postcodeForm.elements.postcode;
        var result = section.querySelector('[data-postcode-result]');
        var postcode = (input.value || '').toUpperCase().replace(/\s+/g, ' ').trim();
        var earlyAccess = postcodeForm.elements.early_access && postcodeForm.elements.early_access.checked;
        if (postcode.length < 3) { result.textContent = 'Please enter a valid UK office postcode.'; input.focus(); return; }
        var core = prefixes.some(function (prefix) { return postcode.indexOf(prefix) === 0; });
        if (core) {
          result.innerHTML = 'Great news — this appears to be in our core delivery area. <a href="#HomepageFreeSampleForm">Request your free sample.</a>';
        } else if (earlyAccess) {
          result.innerHTML = 'This is outside our usual postcode range, but your 24-hour access may make an early-hours delivery possible. <a href="#HomepageFreeSampleForm">Send your details</a> and we’ll confirm the route.';
        } else {
          result.innerHTML = 'This appears to be outside our usual postcode range. If your office has 24-hour access and can accept an early-hours drop-off, tick the box above and check again. You can also <a href="#HomepageFreeSampleForm">send your details</a> for a route check.';
        }
      });
    }
    var savingsForm = section.querySelector('[data-savings-form]');
    if (savingsForm) {
      savingsForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var current = parseFloat(savingsForm.elements.current_cost.value), boxes = parseInt(savingsForm.elements.boxes.value, 10), deliveries = parseInt(savingsForm.elements.deliveries.value, 10), boxPrice = parseFloat(section.dataset.boxPrice) || 22.5;
        if (!isFinite(current) || !isFinite(boxes) || !isFinite(deliveries)) return;
        var fruitdesk = boxPrice * boxes * deliveries, difference = current - fruitdesk;
        var message = difference > 0 ? 'Potential weekly saving: £' + difference.toFixed(2) : difference < 0 ? 'Difference from current spend: £' + Math.abs(difference).toFixed(2) + ' more per week' : 'The estimated weekly costs are the same.';
        section.querySelector('[data-savings-result]').innerHTML = '<p>Estimated FruitDesk weekly cost</p><strong>£' + fruitdesk.toFixed(2) + '</strong><span>' + message + ' <a href="#HomepageFreeSampleForm">Request a tailored quote &gt;</a></span>';
      });
    }
  });
});
